import React from 'react';


export const createFlexSpacer = () => <div style={{flexGrow: 1}}/>;

export const createHorSpacer = (space) => <span style={{width: space}} />